
export const formatPrice = (price: number, minimumFractionDigits = 2): string => {
  const options: any = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
  }
  const formatter: Intl.NumberFormat = new Intl.NumberFormat('en-US', options)
  return `${formatter.format((price / 100))}`
}

export interface SlicePriceOptions {
  dollar: number
  isCent: boolean
  cent: string
  full: string
  fullCent: string
}

export const slicePrice = (price: number): SlicePriceOptions => {
  const currentPrice = Math.floor(price)
  const dollar = Math.floor(currentPrice / 100)
  const isCent = currentPrice % 100 !== 0
  const cent = currentPrice % 100 === 0
    ? '00'
    : String(currentPrice % 100).padStart(2, '0')

  const full = `${dollar}${isCent ? `.${cent}` : ''}`
  const fullCent = `${dollar}.${cent}`

  return {
    dollar,
    isCent,
    cent,
    full,
    fullCent,
  }
}

export const formatWholePrice = (price: number, method: 'round' | 'floor' | 'ceil' = 'round'): string => {
  return '$' + Math[method](price / 100)
}
